/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Report with results for the active rule for a flag in a project.
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * System generated Unique ID of the Report
     * @type {number}
     * @memberof Report
     */
    readonly id: number;
    /**
     * The URN for the Report
     * @type {string}
     * @memberof Report
     */
    readonly urn: string;
    /**
     * User-facing Unique identifier of the Report. Same as rule key with report ID appended.
     * @type {string}
     * @memberof Report
     */
    readonly key: string;
    /**
     * User-facing name of the Report. Same as rule name.
     * @type {string}
     * @memberof Report
     */
    name: string;
    /**
     * Additional context of the Report
     * @type {string}
     * @memberof Report
     */
    description?: string;
    /**
     * The Key of the Flag this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly flag_key: string;
    /**
     * The Name of the Flag this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly flag_name?: string;
    /**
     * The Key of the Rule this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly rule_key: string;
    /**
     * The Name of the Rule this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly rule_name?: string;
    /**
     * The description of the Rule this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly rule_description?: string;
    /**
     * State of the Rule this report belong to
     * @type {string}
     * @memberof Report
     */
    readonly rule_state?: string;
    /**
     * Type of report.
     * @type {string}
     * @memberof Report
     */
    readonly type: ReportTypeEnum;
    /**
     * Timestamp from when the Report is computed
     * @type {Date}
     * @memberof Report
     */
    readonly start_time?: Date;
    /**
     * Timestamp until when the Report is computed
     * @type {Date}
     * @memberof Report
     */
    readonly end_time?: Date;
    /**
     * Indicates if the Report is archived or not
     * @type {boolean}
     * @memberof Report
     */
    archived?: boolean;
    /**
     * Timestamp when the Report is created
     * @type {Date}
     * @memberof Report
     */
    readonly created_time: Date;
    /**
     * Timestamp when the Report is last updated
     * @type {Date}
     * @memberof Report
     */
    readonly updated_time: Date;
    /**
     * Link to the results UI associated with this Report
     * @type {string}
     * @memberof Report
     */
    readonly fetch_results_ui_url?: string;
    /**
     * Link to the results API associated with this Report
     * @type {string}
     * @memberof Report
     */
    readonly fetch_results_api_url?: string;
    /**
     * Link to reset results associated with this Report
     * @type {string}
     * @memberof Report
     */
    readonly reset_results_url?: string;
    /**
     * Link to self
     * @type {string}
     * @memberof Report
     */
    readonly url: string;
    /**
     * Link to flag url to which this report belongs to
     * @type {string}
     * @memberof Report
     */
    readonly fetch_flag_url?: string;
    /**
     * Link to archive this Report
     * @type {string}
     * @memberof Report
     */
    readonly archive_url?: string;
    /**
     * Link to unarchive this Report
     * @type {string}
     * @memberof Report
     */
    readonly unarchive_url?: string;
    /**
     * Link to delete this Report
     * @type {string}
     * @memberof Report
     */
    readonly delete_url?: string;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Report
     */
    readonly revision?: number;
    /**
     * Granular permission role
     * @type {string}
     * @memberof Report
     */
    readonly role?: string;
    /**
     * Type of rule distribution
     * @type {string}
     * @memberof Report
     */
    readonly distribution_mode?: ReportDistributionModeEnum;
    /**
     * Experiment ID or Layer Experiment of a rule
     * @type {number}
     * @memberof Report
     */
    readonly layer_experiment_id?: number;
    /**
     * The first metric in the list of metrics.
     * @type {string}
     * @memberof Report
     */
    readonly primary_metric?: string;
}

export function ReportFromJSON(json: any): Report {
    return ReportFromJSONTyped(json, false);
}

export function ReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Report {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'urn': json['urn'],
        'key': json['key'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'flag_key': json['flag_key'],
        'flag_name': !exists(json, 'flag_name') ? undefined : json['flag_name'],
        'rule_key': json['rule_key'],
        'rule_name': !exists(json, 'rule_name') ? undefined : json['rule_name'],
        'rule_description': !exists(json, 'rule_description') ? undefined : json['rule_description'],
        'rule_state': !exists(json, 'rule_state') ? undefined : json['rule_state'],
        'type': json['type'],
        'start_time': !exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'end_time': !exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'created_time': (new Date(json['created_time'])),
        'updated_time': (new Date(json['updated_time'])),
        'fetch_results_ui_url': !exists(json, 'fetch_results_ui_url') ? undefined : json['fetch_results_ui_url'],
        'fetch_results_api_url': !exists(json, 'fetch_results_api_url') ? undefined : json['fetch_results_api_url'],
        'reset_results_url': !exists(json, 'reset_results_url') ? undefined : json['reset_results_url'],
        'url': json['url'],
        'fetch_flag_url': !exists(json, 'fetch_flag_url') ? undefined : json['fetch_flag_url'],
        'archive_url': !exists(json, 'archive_url') ? undefined : json['archive_url'],
        'unarchive_url': !exists(json, 'unarchive_url') ? undefined : json['unarchive_url'],
        'delete_url': !exists(json, 'delete_url') ? undefined : json['delete_url'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'distribution_mode': !exists(json, 'distribution_mode') ? undefined : json['distribution_mode'],
        'layer_experiment_id': !exists(json, 'layer_experiment_id') ? undefined : json['layer_experiment_id'],
        'primary_metric': !exists(json, 'primary_metric') ? undefined : json['primary_metric'],
    };
}

export function ReportToJSON(value?: Report | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'archived': value.archived,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReportTypeEnum {
    AB = 'a/b',
    MultiArmedBandit = 'multi_armed_bandit',
    ContextualMultiArmedBandit = 'contextual_multi_armed_bandit'
}
/**
* @export
* @enum {string}
*/
export enum ReportDistributionModeEnum {
    Manual = 'manual',
    StatsAccelerator = 'stats_accelerator'
}


